import { render, staticRenderFns } from "./OrderCardStatusesMenu.vue?vue&type=template&id=402c99d8&scoped=true&"
import script from "./OrderCardStatusesMenu.vue?vue&type=script&lang=js&"
export * from "./OrderCardStatusesMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardStatusesMenu.vue?vue&type=style&index=0&id=402c99d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c99d8",
  null
  
)

export default component.exports